import Core from "@/modules/core/service/Core";

const url = {
    mailboxes: "/api/inbox/mailbox",
    batch    : "/api/inbox/mailbatch"
}

export default {
    mailboxes () {
        return Core.method.get(url.mailboxes);
    },

    execute (payload) {
        return Core.method.postVoid(url.batch, payload);
    }
}